"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var remove_domain_1 = require("@opten/url/remove-domain");
function getScriptBySrc(src) {
    // HINT: NEVER EVER change to Array.from() we need this code in load-polyfill
    // and IE doesn't understand this until the polyfills are obviously loaded!
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
        var currentScriptElement = scripts.item(i);
        var currentSrc = remove_domain_1.default(currentScriptElement.src);
        if (currentSrc === src) {
            return currentScriptElement;
        }
    }
    return null;
}
exports.default = getScriptBySrc;
